import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { journalEntries } from "../data/journal";
import SiteFooter from "./SiteFooter";
import thresholdTexture from "../assets/threshold-texture.webp";

const EASE = [0.22, 1, 0.36, 1];

export default function Journal({ onBack }) {
  const [reading, setReading] = useState(null);

  return (
    <motion.section
      className="journal-page"
      data-testid="journal-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.9, ease: "easeOut" }}
    >
      <div
        className="about-texture"
        style={{ backgroundImage: `url(${thresholdTexture})` }}
        aria-hidden="true"
      />
      <div className="back-bar">
        <button onClick={onBack} data-testid="journal-back-button">
          ← The Hall
        </button>
        <div className="bb-right">
          <button className="mark" data-testid="journal-brand-hall-button" onClick={onBack} aria-label="Back to The Hall">
            The WOWOW Gallery
          </button>
        </div>
      </div>

      <motion.div
        className="journal-body"
        initial={{ opacity: 0, y: 26 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.25, ease: EASE }}
      >
        <div className="eyebrow">From the Gallery</div>
        <h1 className="display">The Journal</h1>

        {journalEntries.length === 0 ? (
          <p className="journal-empty" data-testid="journal-empty">
            The first entry is being framed — check back soon.
          </p>
        ) : (
          <div className="journal-grid">
            {journalEntries.map((entry, i) => (
              <button
                className="journal-card"
                data-testid={`journal-entry-${i + 1}`}
                key={entry.id}
                onClick={() => setReading(entry)}
              >
                <span className="journal-card-media">
                  <img src={entry.image} alt={entry.title} loading="lazy" />
                </span>
                <span className="journal-card-title">{entry.title}</span>
              </button>
            ))}
          </div>
        )}
      </motion.div>

      <SiteFooter />

      <AnimatePresence>
        {reading && (
          <motion.div
            className="journal-reader"
            data-testid="journal-reader"
            data-lenis-prevent
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            <button
              className="journal-reader-close"
              data-testid="journal-reader-close-button"
              onClick={() => setReading(null)}
              aria-label="Back to the Journal"
            >
              ← The Journal
            </button>
            <motion.div
              className="journal-reader-body"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.15, ease: EASE }}
            >
              <span className="journal-reader-media">
                <img src={reading.image} alt={reading.title} />
              </span>
              <div className="eyebrow">The Journal</div>
              <h2 className="display" data-testid="journal-reader-title">{reading.title}</h2>
              {reading.dek && <p className="journal-reader-dek">{reading.dek}</p>}
              {reading.body.split(/\n\n+/).map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.section>
  );
}
